"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.077 4.138l.49-.103a.5.5 0 00-.973-.027l.483.13zM5.862.922l.13.483a.5.5 0 00-.027-.972l-.103.49zM8.667 5A3.667 3.667 0 015 8.666v1A4.667 4.667 0 009.667 5h-1zm-.079-.76c.051.245.079.499.079.76h1c0-.33-.035-.654-.1-.965l-.979.206zm.006-.232a2.125 2.125 0 01-2.05 1.572v1c1.444 0 2.66-.981 3.016-2.313l-.966-.259zM6.544 5.58A2.123 2.123 0 014.42 3.456h-1A3.123 3.123 0 006.543 6.58v-1zM4.42 3.456c0-.98.666-1.808 1.571-2.05L5.733.438A3.125 3.125 0 003.42 3.456h1zM5 1.333c.26 0 .515.027.76.079l.205-.979A4.684 4.684 0 005 .333v1zM1.333 5A3.667 3.667 0 015 1.333v-1A4.667 4.667 0 00.333 5h1zM5 8.666A3.667 3.667 0 011.333 5h-1A4.667 4.667 0 005 9.666v-1z",
    fill: "#4D4D4D"
  }));
}

var MemoSvgMoon = /*#__PURE__*/React.memo(SvgMoon);
var _default = MemoSvgMoon;
exports["default"] = _default;